"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginPartialCloseError = exports.MarginRisk = exports.ProtectionOrderError = exports.SizeError = exports.PriceError = exports.MarginOrderDirection = exports.MarginOrderType = exports.ProtectionOrderVariant = exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType[InputType["Price"] = 0] = "Price";
    InputType[InputType["Size"] = 1] = "Size";
})(InputType = exports.InputType || (exports.InputType = {}));
var ProtectionOrderVariant;
(function (ProtectionOrderVariant) {
    ProtectionOrderVariant[ProtectionOrderVariant["StopLoss"] = 0] = "StopLoss";
    ProtectionOrderVariant[ProtectionOrderVariant["TakeProfit"] = 1] = "TakeProfit";
})(ProtectionOrderVariant = exports.ProtectionOrderVariant || (exports.ProtectionOrderVariant = {}));
var MarginOrderType;
(function (MarginOrderType) {
    MarginOrderType[MarginOrderType["Market"] = 0] = "Market";
    MarginOrderType[MarginOrderType["Limit"] = 1] = "Limit";
    MarginOrderType[MarginOrderType["Stop"] = 2] = "Stop";
})(MarginOrderType = exports.MarginOrderType || (exports.MarginOrderType = {}));
var MarginOrderDirection;
(function (MarginOrderDirection) {
    MarginOrderDirection[MarginOrderDirection["Long"] = 0] = "Long";
    MarginOrderDirection[MarginOrderDirection["Short"] = 1] = "Short";
})(MarginOrderDirection = exports.MarginOrderDirection || (exports.MarginOrderDirection = {}));
var PriceError;
(function (PriceError) {
    PriceError[PriceError["PriceIsZero"] = 0] = "PriceIsZero";
    PriceError[PriceError["LimitPriceAboveBuy"] = 1] = "LimitPriceAboveBuy";
    PriceError[PriceError["LimitPriceBelowSell"] = 2] = "LimitPriceBelowSell";
    PriceError[PriceError["StopPriceBelowBuy"] = 3] = "StopPriceBelowBuy";
    PriceError[PriceError["StopPriceAboveSell"] = 4] = "StopPriceAboveSell";
    PriceError[PriceError["TooMuchPrecision"] = 5] = "TooMuchPrecision";
})(PriceError = exports.PriceError || (exports.PriceError = {}));
var SizeError;
(function (SizeError) {
    SizeError[SizeError["OrderBelowMin"] = 0] = "OrderBelowMin";
    SizeError[SizeError["OrderAboveMax"] = 1] = "OrderAboveMax";
    SizeError[SizeError["OrderAboveUserMax"] = 2] = "OrderAboveUserMax";
    SizeError[SizeError["IncrementTooSmall"] = 3] = "IncrementTooSmall";
})(SizeError = exports.SizeError || (exports.SizeError = {}));
var ProtectionOrderError;
(function (ProtectionOrderError) {
    ProtectionOrderError[ProtectionOrderError["StopLossAboveMax"] = 0] = "StopLossAboveMax";
    ProtectionOrderError[ProtectionOrderError["StopLossBelowMin"] = 1] = "StopLossBelowMin";
    ProtectionOrderError[ProtectionOrderError["TakeProfitAboveMax"] = 2] = "TakeProfitAboveMax";
    ProtectionOrderError[ProtectionOrderError["TakeProfitBelowMin"] = 3] = "TakeProfitBelowMin";
    ProtectionOrderError[ProtectionOrderError["TooMuchPrecision"] = 4] = "TooMuchPrecision";
})(ProtectionOrderError = exports.ProtectionOrderError || (exports.ProtectionOrderError = {}));
var MarginRisk;
(function (MarginRisk) {
    MarginRisk[MarginRisk["None"] = 0] = "None";
    MarginRisk[MarginRisk["Healthy"] = 1] = "Healthy";
    MarginRisk[MarginRisk["Monitor"] = 2] = "Monitor";
    MarginRisk[MarginRisk["Warning"] = 3] = "Warning";
    MarginRisk[MarginRisk["AtRisk"] = 4] = "AtRisk";
    MarginRisk[MarginRisk["StopOut"] = 5] = "StopOut";
})(MarginRisk = exports.MarginRisk || (exports.MarginRisk = {}));
var MarginPartialCloseError;
(function (MarginPartialCloseError) {
    MarginPartialCloseError[MarginPartialCloseError["BelowMinimumLots"] = 0] = "BelowMinimumLots";
    MarginPartialCloseError[MarginPartialCloseError["RemainingBelowMinimumLots"] = 1] = "RemainingBelowMinimumLots";
    MarginPartialCloseError[MarginPartialCloseError["AboveRemainingLots"] = 2] = "AboveRemainingLots";
})(MarginPartialCloseError = exports.MarginPartialCloseError || (exports.MarginPartialCloseError = {}));
//# sourceMappingURL=ui.types.js.map